import { render, staticRenderFns } from "./RecruitmentDashboard.vue?vue&type=template&id=609ade48&"
import script from "./RecruitmentDashboard.vue?vue&type=script&lang=js&"
export * from "./RecruitmentDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports